(() => {
  const init = () => document.querySelectorAll('[data-wreath-compare]').forEach(root => {
    if (root.dataset.wreathReady) return;
    const select = root.querySelector('[data-wreath-size]');
    const grid = root.querySelector('[data-wreath-grid]');
    const status = root.querySelector('[data-wreath-status]');
    const retry = root.querySelector('[data-wreath-retry]');
    const template = root.querySelector('[data-wreath-card-template]');
    let words, sources;
    try {
      words = JSON.parse(root.querySelector('[data-wreath-labels]').textContent);
      sources = JSON.parse(root.querySelector('[data-wreath-products]').textContent);
    } catch { return; }
    if (!select || !grid || !status || !retry || !template || !Array.isArray(sources) || sources.length !== 9 || new Set(sources.map(s => s.id)).size !== 9 || new Set(sources.map(s => s.handle)).size !== 9) return;
    if (['prompt', 'count', 'empty', 'loading', 'error', 'view', 'sold_out'].some(k => typeof words[k] !== 'string')) return;
    const sizes = new Set(["3'", "4'", "6'", "8'", "10'", "12'"]);
    const currencyOkay = () => window.shopCustomer === false && window.Shopify?.currency?.active === 'USD' && (!window.Currency?.currentCurrency || window.Currency.currentCurrency === 'USD');
    const base = new URL(root.dataset.productsRoot, location.origin);
    const cartURL = new URL(root.dataset.cartUrl, location.origin);
    if (base.origin !== location.origin || cartURL.origin !== location.origin || !base.pathname.endsWith('/products/') || !currencyOkay()) return;
    let generation = 0, controller = null, products = null;
    const clear = message => { grid.replaceChildren(); grid.hidden = true; status.textContent = message; };
    const photoURL = value => {
      if (typeof value !== 'string') throw new Error('Photo shape');
      const u = new URL(value, location.origin);
      const owned = u.protocol === 'https:' && ((u.hostname === 'cdn.shopify.com' && u.pathname.startsWith('/s/files/1/0565/5779/7528/')) || (u.origin === location.origin && u.pathname.startsWith('/cdn/shop/')));
      if (!owned || !/\.(?:jpg|jpeg|png|webp|avif)$/i.test(u.pathname)) throw new Error('Photo identity');
      u.searchParams.set('width', '480');
      return u.href;
    };
    const check = (p, source) => {
      if (p?.id !== source.id || p.handle !== source.handle || typeof p.title !== 'string' || !p.published_at || p.requires_selling_plan || p.selling_plan_groups?.length) throw new Error('Product identity');
      if (!Array.isArray(p.options) || p.options.length !== 1 || p.options[0].name !== 'Size' || !Array.isArray(p.variants) || p.variants.length !== source.variants.length) throw new Error('Product options');
      const wanted = new Map(source.variants.map(v => [v.id, v]));
      const seen = new Set();
      p.variants.forEach(v => {
        const expected = wanted.get(v.id);
        if (!expected || seen.has(v.id) || v.sku !== expected.sku || v.option1 !== expected.size || v.title !== expected.size || v.option2 != null || v.option3 != null || typeof v.available !== 'boolean' || !Number.isSafeInteger(v.price) || v.price <= 0 || v.requires_selling_plan || v.quantity_price_breaks?.length) throw new Error('Variant identity');
        seen.add(v.id);
      });
      photoURL(p.featured_image);
      return p;
    };
    const read = async (url, signal) => {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json' } });
      if (!response.ok || signal.aborted) throw new Error('Read failed');
      return response.json();
    };
    const update = async () => {
      const selected = select.value, own = ++generation;
      controller?.abort(); controller = null; retry.hidden = true;
      if (!currencyOkay()) { products = null; clear(words.prompt); root.hidden = true; return; }
      if (!sizes.has(selected)) { clear(words.prompt); return; }
      clear(words.loading);
      const active = new AbortController(); controller = active;
      const deadline = setTimeout(() => active.abort(), 10000);
      try {
        const cart = await read(cartURL.href, active.signal);
        if (cart.currency !== 'USD' || !currencyOkay()) { products = null; clear(words.prompt); root.hidden = true; return; }
        let current = products;
        if (!current) {
          current = new Array(sources.length);
          let next = 0;
          await Promise.all(Array.from({ length: 3 }, async () => {
            while (next < sources.length) {
              const i = next++, source = sources[i];
              if (!Number.isSafeInteger(source.id) || !/^[a-z0-9-]+$/.test(source.handle)) throw new Error('Source identity');
              current[i] = check(await read(new URL(source.handle + '.js', base).href, active.signal), source);
            }
          }));
        }
        if (own !== generation || active.signal.aborted || !currencyOkay() || select.value !== selected) return;
        products = current;
        const fragment = document.createDocumentFragment();
        let count = 0;
        current.forEach(p => {
          const v = p.variants.find(v => v.option1 === selected);
          if (!v) return;
          const card = template.content.firstElementChild.cloneNode(true);
          const link = new URL(p.handle, base); link.searchParams.set('variant', String(v.id));
          card.href = link.href; card.dataset.wreathSize = selected;
          card.querySelector('h3').textContent = p.title;
          card.querySelector('[data-wreath-dimension]').textContent = selected;
          const img = card.querySelector('img'); img.src = photoURL(v.featured_image?.src || p.featured_image); img.alt = p.title;
          card.querySelector('.dl-wreath-compare__price').textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v.price / 100) + ' USD';
          card.querySelector('.tree-card__btn').textContent = words.view;
          const unavailable = card.querySelector('[data-wreath-unavailable]'); unavailable.textContent = words.sold_out; unavailable.hidden = v.available;
          fragment.append(card); count++;
        });
        grid.replaceChildren(fragment); grid.hidden = count === 0;
        status.textContent = count ? words.count.replace('__COUNT__', String(count)) : words.empty;
      } catch {
        if (own === generation && currencyOkay()) { products = null; clear(words.error); retry.hidden = false; }
        else if (own === generation) { products = null; clear(words.prompt); root.hidden = true; }
      } finally {
        active.abort(); clearTimeout(deadline);
        if (controller === active) controller = null;
      }
    };
    root.dataset.wreathReady = 'true'; root.hidden = false; clear(words.prompt);
    select.addEventListener('change', update);
    retry.addEventListener('click', update);
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('#currencies a[data-currency]')) { ++generation; controller?.abort(); products = null; clear(words.prompt); root.hidden = true; }
    }, true);
    window.addEventListener('pageshow', event => {
      if (event.persisted) { ++generation; controller?.abort(); products = null; select.value = ''; clear(words.prompt); }
      if (!currencyOkay()) { ++generation; controller?.abort(); root.hidden = true; }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
